// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"1f291aa7","365":"7436ba02","375":"d4c96386","787":"c1ea0fec"}[chunkId] + ".chunk.js";
};